// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1732":"b30fc604","6620":"d2d567c8"}[chunkId] + ".chunk.css";
};